import defaultConfig from '../../default'
import HeaderLogo from './HeaderLogo.svelte'
import type { GatewayConfig } from '../../declarations'
import ShowcaseIcon from 'images/icon-ribbon.png'
import ArticleIcon from 'images/icon-article.png'
import GalleryIcon from 'images/icon-gallery.png'
import MapIcon from 'images/icon-map.png'
import DatasetIcon from 'images/icon-dataset.png'
import GroupIcon from 'images/icon-group.png'
import DatasetDefinitionIcon from 'images/icon-dataset-definition.png'
import PersonIcon from 'images/icon-person.png'
import TeamIcon from 'images/icon-team.png'
import EventsIcon from 'images/icon-events.png'

export default {
  ...defaultConfig,

  gateway: 'srlcc',
  title: window.gettext('Southern Rockies Landscape Conservation Cooperative'),
  logoComponent: HeaderLogo,
  footer: [
    {
      label: window.gettext('Southern Rockies LLC'),
      href: 'http://southernrockieslcc.org/',
    },
    {
      label: window.gettext('About Data Basin'),
      href: '/about/',
    },
    {
      label: window.gettext('Terms of Use'),
      href: '/pages/terms-service/',
    },
    {
      label: window.gettext('Contact'),
      href: '/services/contact/',
    },
  ],
  navigation: user => [
    {
      id: 'get-started',
      label: window.gettext('Get Started'),
      items: [
        {
          type: 'link',
          label: window.gettext('About the SRLCC CPA'),
          href: '/pages/about-slrcc/',
        },
        {
          type: 'link',
          label: window.gettext('Take a Tour'),
          href: '/tour/',
        },
        {
          type: 'link',
          label: window.gettext('Become a Data Basin Member'),
          href: '/auth/create_account/',
        },
        {
          type: 'divider',
        },
        {
          type: 'link',
          label: window.gettext('Help'),
          href: '/help/',
          bold: true,
        },
        {
          type: 'link',
          label: window.gettext('Glossary'),
          href: '/glossary/',
          bold: true,
        },
      ],
    },

    {
      id: 'explore',
      label: window.gettext('Find'),
      items: [
        {
          type: 'link',
          label: window.gettext('Showcase'),
          image: ShowcaseIcon,
          href: '/showcase/',
        },
        {
          type: 'link',
          label: window.gettext('Galleries'),
          image: GalleryIcon,
          href: '/galleries/',
        },
        {
          type: 'link',
          label: window.gettext('Maps'),
          image: MapIcon,
          href: '/maps/',
        },
        {
          type: 'link',
          label: window.gettext('Datasets'),
          image: DatasetIcon,
          href: '/datasets/',
        },
        {
          type: 'link',
          label: window.gettext('Groups'),
          image: GroupIcon,
          href: '/groups/',
        },
      ],
    },

    defaultConfig.navigation(user).find(menu => menu.id === 'create'),

    {
      id: 'community',
      label: window.gettext('Collaborate'),
      width: '215px',
      items: [
        {
          type: 'text',
          text: window.gettext(
            'Groups provide a way to collaborate with others, by giving you space to pull together shared resources.',
          ),
        },
        {
          type: 'divider',
        },
        {
          type: 'link',
          label: window.gettext('Groups'),
          image: GroupIcon,
          href: '/groups/',
        },
        {
          type: 'link',
          label: window.gettext('Create a Group'),
          image: GroupIcon,
          href: '/groups/new/',
        },
      ],
    },
  ],
  pages: {
    ...defaultConfig.pages,
    home: () => import('./Home.svelte'),
  },
} as GatewayConfig
